import React, { useState, useEffect } from "react";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import { useLocation, useNavigate } from "react-router-dom";
import CalendarDay from "./CalenderComponent/CalendarDay";
import CalendarWeeks from "./CalenderComponent/CalendarWeeks";
import CalendarMonth from "./CalenderComponent/CalendarMonth";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import CalendarYear from "./CalenderComponent/CalendarYear";
import OTSViewModel from "../DashboardReceivedOrders/OrderRequests/Models/OTSViewModel";
import { Modal } from "reactstrap";
import CalenderModel from "./CalenderModel";
import { useRouteBaseStateContext } from "../../../Context/RouteBaseStateContext";
import CalenderTeamsAddTaskModel from "../TeamAndCollaboration/TeamTabs/TeamsModels/CalenderTeamsAddTaskModel";

export default function CalendarManagement() {
  const laung = localStorage.getItem("laung");
  const [action, setAction] = useState(0);
  const [viewmodel, setviewModel] = useState(false);
  const [model, setModel] = useState(false);
  const [modelholiday, setModelholiday] = useState(false);

  const { state } = useLocation()
  const id = state?.id || 0

  const [lan, setLan] = useState(laung ?? "en");
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const navigate = useNavigate();
  const { urlstate, setCalenderroute } = useRouteBaseStateContext();
  const [activeTab, setActiveTab] = useState("Week");

  useEffect(() => {
    if (urlstate?.canderroute) {
      handleTabClick(urlstate?.canderroute || "Week");
    } else {
      handleTabClick("Week");
    }
  }, [urlstate?.canderroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setCalenderroute(tab);
  };

  useEffect(() => {
    if (viewmodel || model || modelholiday) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [viewmodel, model, modelholiday]);

  let roleType = localStorage.getItem("role_type");

  
  useEffect(() => {
    if(action!=0){
      window.location.reload()
    }

  }, [action]);

  return (
    <div className="project-section calendar-section">
      <div className="col-lg-10 mx-auto tab-sec">
        <div
          style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', marginBottom: '32px' }}
          className="tab-content calendar-flex"
        >
          <div className="calendar-head">
            <h4 onClick={() => { setModel(true) }}>Manage calendar</h4>
          </div>
          <ul className="nav nav-tabs m-0">
            <li className="nav-item">
              <a

                data-toggle="tab"
                className={`nav-link ${activeTab == "Week" ? "active" : ""}`}
                onClick={() => handleTabClick("Week")}
              >
                Week
              </a>
            </li>
            <li className="nav-item">
              <a

                data-toggle="tab"
                className={`nav-link ${activeTab == "Month" ? "active" : ""}`}
                onClick={() => handleTabClick("Month")}
              >
                Month
              </a>
            </li>
            <li className="nav-item">
              <a

                data-toggle="tab"
                className={`nav-link ${activeTab == "Year" ? "active" : ""}`}
                onClick={() => handleTabClick("Year")}
              >
                Year
              </a>
            </li>
          </ul>
          <div className="setting-add-task">
            <button className="buttons border-button" onClick={() => navigate(`/${lan}/account/calendarsetting`)}>
              <img src={`${CloudStorage.cloudurl}/Assets/Images/common/settings.png`} alt="" />Settings
            </button>
            {roleType == 4 && <button className="buttons background-button" onClick={() => { setModel(true) }} >
              <span className=""><img src={`${CloudStorage.cloudurl}/Assets/Images/common/plus.svg`} alt="" />
                Add task</span>
            </button>}

            <button className="buttons border-button" onClick={() => { setModelholiday(true) }} >
              <img style={{ width: '17px', height: "17px" }} src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/plus.svg`} alt="" />Add unavailable days
            </button>
          </div>

        </div>
        <div className="tab-content">
          <div
            className={`tab-pane ${activeTab == "Week" ? "active" : ""}`}
            id="recentview"
          >
            {activeTab == "Week" && <CalendarWeeks id={id} action={action} />}
          </div>
          <div
            className={`tab-pane ${activeTab == "Month" ? "active" : ""}`}
            id="savepost"
          >
            {activeTab == "Month" && <CalendarMonth id={id} action={action} />}
          </div>
          <div
            className={`tab-pane ${activeTab == "Year" ? "active" : ""}`}
            id="appliedpost"
          >
            {activeTab == "Year" && <CalendarYear id={id} action={action} />}
          </div>
        </div>
      </div>
      <div
        className={`teamviewdetail w-100 ${viewmodel == true ? "show" : ""}`}
        isOpen={viewmodel}
      >
        <OTSViewModel
          setviewModel={(value) => {
            setviewModel(value);
            setAction(action + 1)
          }}
        />
      </div>

      <Modal className="popupmodal" isOpen={model}>
        <CalenderTeamsAddTaskModel
          setModel={(value) => {
            setModel(value);
            setAction(action + 1)
          }}
        />
      </Modal>
      <Modal className="popupmodal" isOpen={modelholiday}>
        <CalenderModel
          setModel={(value) => {
            setModelholiday(value);
            setAction(action + 1)
          }}
        />
      </Modal>
    </div>
  );
}
